export default "__VITE_ASSET__86ba5dc9__"